import * as React from 'react';
import { Chip as Chip$1 } from '@mui/material';

var Chip = function Chip(_ref) {
  var id = _ref.id,
      label = _ref.label,
      onClick = _ref.onClick,
      onDelete = _ref.onDelete,
      color = _ref.color,
      icon = _ref.icon,
      className = _ref.className,
      clickable = _ref.clickable,
      sx = _ref.sx;
  return /*#__PURE__*/React.createElement(Chip$1, {
    id: id,
    label: label,
    onClick: onClick,
    onDelete: onDelete,
    color: color,
    icon: icon,
    clickable: clickable,
    className: className,
    "aria-label": label,
    sx: sx
  });
};

Chip.defaultProps = {
  label: 'label'
};
Chip.displayName = 'Chip';
export { Chip };